<template>
    <div class="dashboard--btn main" @click="$emit('click')" :style="{ backgroundImage: `url(${bg})` }">
        <img :src="icon" alt="" />
        <div class="dashboard--btn__title">
            <div v-if="selectLang == 'vi'">
                <div class="dashboard--btn__title-secondary">{{ titleSecondary }}</div>
                <div class="dashboard--btn__title-primary">{{ titlePrimary }}</div>
            </div>
            <div v-else>
                <div class="dashboard--btn__title-primary">{{ titlePrimary }}</div>
                <div class="dashboard--btn__title-secondary">{{ titleSecondary }}</div>
            </div>
        </div>
        <div class="w-100">
            <img src="@/assets/images/alarm/dashboard_card_line.png" alt="line" />
        </div>
        <div class="dashboard--btn__subtitle">
            <div>{{ subtitle.primary }}</div>
            <div>{{ subtitle.secondary }}</div>
        </div>
    </div>
</template>

<script>
export default ({
    name: 'MainButton',
    data() {
        return {
            selectLang: localStorage.getItem("localeLang")
        };
    },
    props: {
        icon: {
            type: String,
            required: true
        },
        titlePrimary: {
            type: String,
            required: true
        },
        titleSecondary: {
            type: String,
            required: true
        },
        subtitle: {
            type: Object,
            default: () => ({ primary: '', secondary: '' })
        },
        bg: {
            type: String,
            required: true
        },
    },
    emits: ['click']
})
</script>

<style scoped>
.dashboard--btn.main {
    display: flex;
    flex-direction: column;
    align-items: start;
    border-radius: 8px;
    padding: 20px;
    width: 100%;
    cursor: pointer;

    background-size: cover;
    background-position: center;
}

.dashboard--btn__title {
    display: flex;
    align-items: center;
    margin-top: 4px;
}

.dashboard--btn__title img {
    width: 16px;
    height: 16px;
    margin-right: 1rem;
}

.dashboard--btn__title-primary {
    color: var(--btn-color);
    font-weight: 500;
    font-weight: 600;
    font-size: 20px;
    font-style: normal;
}

.dashboard--btn__title-secondary {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.14px;
}

.dashboard--btn__divider {
    width: 100%;
    height: 1px;
    background: #393737;
    margin: 0.5rem 0;
}

.dashboard--btn__subtitle {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 0.2rem;
    justify-content: flex-start;
}

.dashboard--btn__subtitle div {
    font-size: 12px;
    color: var(--Grayscale-Gray40, #929CAA);
    font-weight: 500;
    line-height: 133.333%; 
    letter-spacing: -0.12px;
}

.w-100 {
    width: 100%;
    margin: 16px auto 6px;
    padding: 0;
}

.w-100 img {
    width: 100%;
    height: 1px;
    flex-shrink: 0;
    mix-blend-mode: overlay;
}

@media (max-width: 400px) {
    .dashboard--btn__title-primary {
        font-size: 16px;
    }

    .dashboard--btn__title-secondary {
        font-size: 14px;
    }

    .dashboard--btn__title img {
        margin-right: 0.2rem;
    }

    .w-100 {
        width: 100%;
        margin: 6px auto 6px;
    }

}
</style>
